<div class="element-value">

  <!-- Previous (lazy loading) container -->
  <div *ngIf="lazy else autocomplete">
    <div class="lazy" (mouseenter)="load()">
      <form>
        <mat-form-field>
          <input matInput 
            [value]="element.value | stripHtml"
            (focus)="load()">
          <span matSuffix>{{ element.unit | unit: 'value': 'short' }}</span>
        </mat-form-field>
      </form>
    </div>
  </div>

  <!-- Number, String and Selection -->
  <ng-template #autocomplete>
    <ng-container *ngIf="element?.inputType !== 'Long String' else paragraph">
      <form>
        <mat-form-field>

          <!-- Input -->
          <input matInput #input 
            [type]="element.inputType === 'Number' ? 'number' : 'text'" 
            [formControl]="form"
            [matAutocomplete]="auto"
            (keydown.enter)="submitOnEnter()">
          <span matSuffix>{{ element.unit | unit: 'value': 'short' }}</span>

          <!-- Dropdown -->
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="optionSelected($event)">
            <mat-option *ngFor="let option of element.options2"
              [class.active]="option.value === element.value && option.label === element.valueKey"
              [value]="option.value">
              <span class="label">{{ option.label }}:</span>
              <span class="value">
                {{ option.value }}
                <span *ngIf="element.unit" class="unit">{{ element.unit | unit: 'value': 'short' }}</span>
              </span>
            </mat-option>

            <!-- Add new option -->
            <mat-option *ngIf="element.inputType === 'Select'" value="addOption()">
              <span class="label"><em>{{ 'addoption' | translate }}</em></span>
            </mat-option>

          </mat-autocomplete>
        </mat-form-field>
      </form>
    </ng-container>
  </ng-template>

  <!-- Paragraph -->
  <ng-template #paragraph>
    <form>
      <mat-form-field>
        <input matInput #inputParagraph 
          [value]="element.value | stripHtml"
          (click)="editParagraph()"
          (focus)="editParagraph()">
        <span matSuffix>{{ element.unit | unit: 'value': 'short' }}</span>
      </mat-form-field>
    </form>
  </ng-template>

</div>